import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVaticanCity = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1407)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 0C18.6274 0 24 5.37262 24 12C24 18.6274 18.6274 24 12 24C12 23.4783 10.4348 12 10.4348 12L12 0Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C5.37262 24 0 18.6274 0 12C0 5.37262 5.37262 0 12 0",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.5952 10.4421L18.8504 13.4255C18.4951 13.9636 18.497 14.6884 18.9079 15.2321C19.4292 15.9216 20.4108 16.0581 21.1004 15.5368C21.79 15.0156 21.9265 14.034 21.4051 13.3444C20.9943 12.8008 20.2973 12.6013 19.6828 12.7964L16.1681 8.1467L15.3357 8.77595L14.0869 9.71973L15.3454 11.3845L16.5952 10.4421ZM19.8419 13.872C20.0718 13.6982 20.399 13.7437 20.5728 13.9735C20.7465 14.2034 20.7011 14.5306 20.4712 14.7044C20.2414 14.8781 19.9141 14.8327 19.7404 14.6028C19.5666 14.3729 19.6121 14.0457 19.8419 13.872Z",
				fill: "#ACABB1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.4633 11.3844L21.7218 9.71967L20.4731 8.7758L19.6407 8.14655L16.126 12.7962C15.5115 12.6011 14.8145 12.8007 14.4036 13.3442C13.8823 14.0339 14.0188 15.0154 14.7084 15.5367C15.398 16.0579 16.3796 15.9215 16.9008 15.2319C17.3117 14.6883 17.3136 13.9634 16.9583 13.4254L19.2135 10.442L20.4633 11.3844ZM16.0684 14.6027C15.8947 14.8327 15.5675 14.8781 15.3376 14.7044C15.1077 14.5305 15.0623 14.2033 15.236 13.9734C15.4098 13.7437 15.737 13.6981 15.9669 13.8719C16.1967 14.0457 16.2422 14.3729 16.0684 14.6027Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1407",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgVaticanCity;
